import { render, staticRenderFns } from "./SubscriptionCalculator.vue?vue&type=template&id=33c1fd5a&"
import script from "./SubscriptionCalculator.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports